// extracted by mini-css-extract-plugin
export default {"root":"GSTInComp_root__P4w9I","no-gstin":"GSTInComp_no-gstin__9bIHo","btn-container":"GSTInComp_btn-container__Jf9-B","edit-btn":"GSTInComp_edit-btn__foT0Y"};